// Small date helpers for code bundled into every page (pages/_app), where
// date-fns would add ~14KB gz. Same semantics as the date-fns functions of the
// same name, in local time.

export function startOfDay(date: Date): Date {
  const result = new Date(date);
  result.setHours(0, 0, 0, 0);
  return result;
}

export function addDays(date: Date, amount: number): Date {
  const result = new Date(date);
  result.setDate(result.getDate() + amount);
  return result;
}

export function isEqual(a: Date, b: Date): boolean {
  return a.getTime() === b.getTime();
}

// "yyyy-MM-dd", or "" when there is no date (like calendarUtils.formatDate).
export function formatYmd(date: Date | null | undefined): string {
  if (!date) return "";
  const pad = (value: number) => String(value).padStart(2, "0");
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
}

// "yyyy-MM-dd" of `date` as seen in `timeZone` (an IANA name like "Asia/Tokyo").
// Gives the same result on the server and in every visitor's browser.
export function formatYmdInTimeZone(date: Date, timeZone: string): string {
  // en-CA formats dates as yyyy-MM-dd.
  return new Intl.DateTimeFormat("en-CA", {
    timeZone,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(date);
}
